var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<span ng-attr-title=\"{{vm.statusLabel[vm.status]}}\"><span ng-class=\"vm.statusMap\" class=\"glyphicon\"></span></span>");;return buf.join("");
}